<template>
  <b-container fluid>
    <backlink />
    <h1>Affaires non facturables</h1>

    <AdminTable id="table" :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="references" slot-scope="{ data }">
        <div v-for="reference in data.value" :key="reference.id">
          <!-- Nouvel onglet : on consulte la référence sans perdre la liste ni ses filtres. -->
          <!-- Lien natif plutôt que <router-link> : b-table capte le clic de la ligne pour la
               sélection, on doit donc l'intercepter avant lui et ouvrir l'onglet nous-mêmes. -->
          <a v-if="$root.isAuthorized('reference_show')" class="reference-link"
            :href="referenceUrl(reference)" target="_blank" rel="noopener"
            @click.stop.prevent="openReference(reference)" @mousedown.stop>
            {{ reference.internal_code }} - {{ reference.product.name }}
          </a>
          <template v-else>{{ reference.internal_code }} - {{ reference.product.name }}</template>
        </div>
      </template>
      <template slot="services" slot-scope="{ data }">
        <div style="width: 75px">
          <b-badge v-if="data.value.includes('outillage')" variant="outillage" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-else variant="transparent" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            &nbsp;
          </b-badge>
          <b-badge v-if="data.value.includes('instruments')" variant="instruments" class="circle float-left"
            v-b-tooltip.hover :title="$store.getters['renting_preparation/getGroup']('instruments').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-else variant="transparent" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            &nbsp;
          </b-badge>
          <b-badge v-if="data.value.includes('service_et_logistique')" variant="service_et_logistique"
            class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('service_et_logistique').text">
            <i class="fa fa-check"></i>
          </b-badge>
        </div>
      </template>
      <template slot="actions" slot-scope="{ data }">
        <b-button @click.prevent="
          agency_number = data.item.agency;
        old_business_number = data.item.number;
        unique_references = data.item.references.map((reference) => ({ id: reference.id }));
        " v-b-modal.modal-transfer v-b-tooltip.hover title="Créer un transfert" variant="outline-secondary">
          <i class="far fa-exchange"></i>
        </b-button>
      </template>
    </AdminTable>

    <b-modal id="modal-transfer" hide-footer centered v-if="agency_number && old_business_number" size="lg">
      <template slot="modal-title">Nouveau transfert</template>
      <TransferForm :params="{
        agency_number: agency_number,
        old_business_number: old_business_number,
        unique_references: unique_references,
      }" @submited="transferCreated()"></TransferForm>
    </b-modal>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";
import TransferForm from "@/components/Transfer/TransferForm";

export default {
  name: "NotBillableBusinessList",
  components: {
    AdminTable,
    TransferForm,
  },
  data() {
    return {
      config: config,
      agency_number: null,
      old_business_number: null,
      unique_references: [],
    };
  },
  computed: {
    options: function () {
      return {
        agency_options: this.$store.getters["agency/getAll"].selectOptions("id", [
          "internal_number",
          " - ",
          "name",
        ]),
        services_options: this.$store.getters["renting_preparation/getGroups"],
      };
    },
  },
  mounted() {
    this.$store.dispatch("agency/getAllForSelect");
  },
  methods: {
    /**
     * Fourni les données à AdminTableSync. Cette méthode est appelée à chaque
     * rafraichissement de la liste
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {object}        {
                                  total: Nombre total de résultats,
                                  items: Items à afficher
                                }
     */
    itemsProvider(ctx) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "business/not_billable", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              agency: ctx.extended_filters_model.agency,
              group_slug: ctx.extended_filters_model.group_slug,
            },
          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.businesses || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
    /**
     * URL de la fiche référence : renseignée sur le lien pour permettre le clic milieu,
     * le « ouvrir dans un nouvel onglet » du navigateur et la copie du lien.
     */
    referenceUrl(reference) {
      return this.$router.resolve({ name: "ReferenceDetail", params: { id: reference.id } }).href;
    },
    openReference(reference) {
      window.open(this.referenceUrl(reference), "_blank", "noopener");
    },
    transferCreated() {
      this.$root.$emit("bv::hide::modal", "modal-transfer");
      this.$root.$emit("refresh", "table");
    },
  },
};
</script>

<style lang="scss" scoped>
.reference-link {
  color: #1ab394;
  cursor: pointer;

  &:hover,
  &:focus {
    color: #18a689;
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NotBillableBusiness/NotBillableBusinessList.vue